module.exports = __webpack_public_path__ + "img/chart-bullet.2269c648.svg";